import { render, staticRenderFns } from "./FollowUpActivities.vue?vue&type=template&id=6e0300a1&scoped=true"
import script from "./FollowUpActivities.vue?vue&type=script&lang=js"
export * from "./FollowUpActivities.vue?vue&type=script&lang=js"
import style0 from "./FollowUpActivities.vue?vue&type=style&index=0&id=6e0300a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0300a1",
  null
  
)

export default component.exports